module.exports = __webpack_public_path__ + "static/media/mainPromote.9becdf14.png";